// import React, { useState } from 'react';
// import axios from 'axios';
// import { Button, Form, Container } from 'react-bootstrap';
// import swal from 'sweetalert';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Sidebar from '../Sidebar/Sidebar';


// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await axios.post('http://localhost:5000/login', { username, password });
//       const { user_id, username, fullname, role } = response.data;

//       // Store user data in session or context
//       sessionStorage.setItem('user_id', user_id);
//       sessionStorage.setItem('username', username);
//       sessionStorage.setItem('fullname', fullname);
//       sessionStorage.setItem('role', role);

//       swal('Login Success', `Welcome ${role}`, 'success');

//       // Redirect to dashboard
//       window.location.href = '/home';  // Assuming you have a dashboard route
//     } catch (error) {
//       setErrorMessage(error.response ? error.response.data.message : 'Server error');
//       swal('Login Fail', errorMessage, 'error');
//     }
//   };

//   return (

//     <>

//     <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
//       <div className="login-box">
//         <div className="login-logo text-center">
//           <img src="img/colourlogo.jpeg" width="50%" alt="Logo" />
//         </div>
//         <div className="login-box-body">
//           <h3 className="login-box-msg">Admin Sales Login</h3>

//           <Form onSubmit={handleLogin}>
//             <Form.Group controlId="username">
//               <Form.Control
//                 type="text"
//                 placeholder="Username"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Form.Group controlId="password">
//               <Form.Control
//                 type="password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Button variant="primary" type="submit" block>
//               Log In
//             </Button>
//           </Form>
//         </div>
//       </div>
//     </Container>




//     </>
//   );
// };

// export default Login;


// import React, { useState } from 'react';
// import { Container, Card, Form, Button, Row, Col } from 'react-bootstrap';
// import axios from 'axios';
// import swal from 'sweetalert2';
// import './Login.css'
// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await axios.post('https://posapi.emedha.in/api/login', { username, password });

//       const { user_id, username, fullname, role } = response.data;

//       // Store user data in session storage (or use a context)  https://posapi.emedha.in
//       sessionStorage.setItem('user_id', user_id);
//       sessionStorage.setItem('username', username);
//       sessionStorage.setItem('fullname', fullname);
//       sessionStorage.setItem('role', role);

//       swal.fire({
//         icon: 'success',
//         title: 'Login Success',
//         text: `Welcome ${role}`,
//       }).then(() => {
//         // Redirect to dashboard (or handle with react-router)
//         window.location.href = '/home';
//       });
//     } catch (error) {
//       setErrorMessage(error.response ? error.response.data.message : 'Server error');
//       swal.fire({
//         icon: 'error',
//         title: 'Login Failed',
//         text: errorMessage,
//       });
//     }
//   };

//   return (
//     <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
//       <Card className="login-card" style={{ width: '25rem' }}>
//         <Card.Body>
//           <div className="login-logo text-center">
//             <img src="img/colourlogo.jpeg" width="50%" alt="Logo" />
//           </div>
//           <h3 className="login-box-msg text-center">Admin Sales Login</h3>

//           <Form onSubmit={handleLogin}>
//             <Form.Group controlId="username">
//               <Form.Control
//                 type="text"
//                 placeholder="Username"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Form.Group controlId="password">
//               <Form.Control
//                 type="password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Row>
//               <Col>
//                 <Button variant="primary" type="submit" block>
//                   Log In
//                 </Button>
//               </Col>
//             </Row>
//           </Form>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// };

// export default Login;



// import React, { useState } from 'react';
// import { Container, Card, Form, Button, Row, Col } from 'react-bootstrap';
// import axios from 'axios';
// import swal from 'sweetalert2';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
// import './Login.css';

// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');
//   const navigate = useNavigate(); // Initialize useNavigate

//   // const handleLogin = async (e) => {
//   //   e.preventDefault();

//   //   try {
//   //     const response = await axios.post('https://posapi.emedha.in/api/login', { username, password });

//   //     const { user_id, username, fullname, role } = response.data;

//   //     // Store user data in session storage
//   //     sessionStorage.setItem('user_id', user_id);
//   //     sessionStorage.setItem('username', username);
//   //     sessionStorage.setItem('fullname', fullname);
//   //     sessionStorage.setItem('role', role);

//   //     swal.fire({
//   //       icon: 'success',
//   //       title: 'Login Success',
//   //       text: `Welcome ${role}`,
//   //     }).then(() => {
//   //       // Redirect to the home page after successful login
//   //       navigate('/');
//   //     });
//   //   } catch (error) {
//   //     setErrorMessage(error.response ? error.response.data.message : 'Server error');
//   //     swal.fire({
//   //       icon: 'error',
//   //       title: 'Login Failed',
//   //       text: errorMessage,
//   //     });
//   //   }
//   // };


//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//         // Send login request to backend
//         const response = await axios.post('https://posapi.emedha.in/api/login', {
//             username,
//             password
//         });

//         const { user_id, username, fullname, role } = response.data;

//         // Store session data in sessionStorage
//         sessionStorage.setItem('user_id', user_id);
//         sessionStorage.setItem('username', username);
//         sessionStorage.setItem('fullname', fullname);
//         sessionStorage.setItem('role', role);

//         // Show success message and navigate to dashboard
//         swal.fire({
//             icon: 'success',
//             title: 'Login Success',
//             text: `Welcome ${role}`,
//         }).then(() => {
//             navigate('/home'); // or the route you want to navigate to after login
//         });
//     } catch (error) {
//         console.error("Login error:", error); // Log the full error object to inspect it

//         // Check if the error is from the response and has the expected structure
//         const message = error.response && error.response.data && error.response.data.message
//             ? error.response.data.message
//             : error.message || 'An unexpected error occurred. Please try again later.';

//         setErrorMessage(message);

//         // Show the error to the user using SweetAlert
//         swal.fire({
//             icon: 'error',
//             title: 'Login Failed',
//             text: message,
//         });
//     }
// };



//   return (
//     <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
//       <Card className="login-card" style={{ width: '25rem' }}>
//         <Card.Body>
//           <div className="login-logo text-center">
//             <img src="img/colourlogo.jpeg" width="50%" alt="Logo" />
//           </div>
//           <h3 className="login-box-msg text-center">Admin Sales Login</h3>

//           <Form onSubmit={handleLogin}>
//             <Form.Group controlId="username">
//               <Form.Control
//                 type="text"
//                 placeholder="Username"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Form.Group controlId="password">
//               <Form.Control
//                 type="password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </Form.Group>

//             <Row>
//               <Col>
//                 <Button variant="primary" type="submit" block>
//                   Log In
//                 </Button>
//               </Col>
//             </Row>
//           </Form>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// };

// export default Login;



// import React, { useState } from 'react';
// import axios from 'axios';
// import swal from 'sweetalert';
// import { Card, Form, Button, Container, Row, Col } from 'react-bootstrap';
// import { FaUser, FaLock } from 'react-icons/fa';  // Import React Icons (FaUser for username, FaLock for password)
// import './Login.css'; // Custom CSS for the additional styling
// import Ganesh from '../images/ganeshlogo.jpeg'


// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);

//   // Handle login form submission
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const response = await axios.post('https://posapi.emedha.in/api/login', { username, password });

//       if (response.data && response.data.username) {
//         sessionStorage.setItem('user_id', response.data.user_id);
//         sessionStorage.setItem('username', response.data.username);
//         sessionStorage.setItem('role', response.data.role);
        
//         swal('Login Success', `Welcome ${response.data.role}`, 'success')
//           .then(() => window.location.href = '/home');
//       } else {
//         swal('Login Failed', 'Username or Password is Incorrect', 'error');
//       }
//     } catch (error) {
//       swal('Login Failed', 'An error occurred during login', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Container fluid className="d-flex justify-content-center align-items-center full-height">
//       {/* <Row className="w-100">
//         <Col xs={12} sm={8} md={6} lg={4} className="d-flex justify-content-center"> */}
//           <Card className="shadow-lg rounded-lg border-0 w-100">
//             <Card.Body className="p-5">
//               <div className="text-center mb-4">
//                 <img width="60%" src={Ganesh} alt="Logo" />
//               </div>
//               <h4 className="text-center mb-4 font-weight-bold">Admin Sales Login</h4>
//               <Form onSubmit={handleLogin}>
//                 <Form.Group controlId="formUsername">
//                   <div className="input-group">
//                     <div className="input-group-prepend">
//                       <span className="input-group-text">
//                         <FaUser />
//                       </span>
//                     </div>
//                     <Form.Control 
//                       type="text" 
//                       placeholder="Username" 
//                       value={username} 
//                       onChange={(e) => setUsername(e.target.value)} 
//                       required 
//                       className="input-field"
//                     />
//                   </div>
//                 </Form.Group>

//                 <Form.Group controlId="formPassword">
//                   <div className="input-group">
//                     <div className="input-group-prepend">
//                       <span className="input-group-text">
//                         <FaLock />
//                       </span>
//                     </div>
//                     <Form.Control 
//                       type="password" 
//                       placeholder="Password" 
//                       value={password} 
//                       onChange={(e) => setPassword(e.target.value)} 
//                       required 
//                       className="input-field"
//                     />
//                   </div>
//                 </Form.Group>

//                 <Button 
//                   variant="primary" 
//                   type="submit" 
//                   block 
//                   disabled={loading} 
//                   className="btn-login"
//                 >
//                   {loading ? 'Logging in...' : 'Log In'}
//                 </Button>
//               </Form>
//             </Card.Body>
//           </Card>
//         {/* </Col>
//       </Row> */}
//     </Container>
//   );
// };

// export default Login;




// import React, { useState } from 'react';
// import axios from 'axios';
// import swal from 'sweetalert';
// import { Card, Form, Button, Container, Row, Col } from 'react-bootstrap';
// import { FaUser, FaLock } from 'react-icons/fa';  // Import React Icons (FaUser for username, FaLock for password)
// import Ganesh from '../images/ganeshlogo.jpeg'
// import { useNavigate } from 'react-router-dom';


// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   // Handle login form submission
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const response = await axios.post('https://posapi.emedha.in/api/login', { username, password });

//       if (response.data && response.data.username) {
//         sessionStorage.setItem('user_id', response.data.user_id);
//         sessionStorage.setItem('username', response.data.username);
//         sessionStorage.setItem('role', response.data.role);
        
//         swal('Login Success', `Welcome ${response.data.role}`, 'success')
//           .then(() => {
//             if (response.data.role === "Admin") {
//               navigate('/home');  // Redirect Admin to /home
//             } else if (response.data.role === "Operator") {
//               navigate('/operatorDashboard');  // Redirect Operator to /operatorDashboard
//             }
//           });
//       } else {
//         swal('Login Failed', 'Username or Password is Incorrect', 'error');
//       }
//     } catch (error) {
//       swal('Login Failed', 'An error occurred during login', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };
//   console.log('this is a username ' , username);
//   console.log('this is a password ' , password );

//   return (
//     <Container
//       fluid
//       style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         minHeight: '100vh',
//         backgroundColor: '#f7f7f7', // Light background color
//       }}
//     >
//       <Card
//         className="shadow-lg rounded-lg border-0 w-100"
//         style={{
//           maxWidth: '400px',
//           width: '100%', // Ensures card takes full width on small screens
//           backgroundColor: 'rgba(255, 255, 255, 0.9)', // Slight transparency
//           borderRadius: '10px',
//         }}
//       >
//         <Card.Body
//           style={{
//             padding: '30px',
//           }}
//         >
//           <div className="text-center mb-4">
//             <img width="60%" src={Ganesh} alt="Logo" style={{ borderRadius: '50%', maxWidth: '100%', height: 'auto' }} />
//           </div>
//           <h4
//             className="text-center mb-4 font-weight-bold"
//             style={{
//               fontSize: '1.5rem',
//               color: '#333',
//               fontWeight: 'bold',
//             }}
//           >
//             Admin Sales Login
//           </h4>
//           <Form onSubmit={handleLogin}>
//             <Form.Group controlId="formUsername">
//               <div className="input-group">
//                 <div className="input-group-prepend">
//                   <span
//                     className="input-group-text"
//                     style={{
//                       backgroundColor: '#007bff',
//                       borderRadius: '50%',
//                       color: 'white',
//                       padding: '10px',
//                       fontSize: '1.2rem',
//                     }}
//                   >
//                     <FaUser />
//                   </span>
//                 </div>
//                 <Form.Control
//                   type="text"
//                   placeholder="Username"
//                   value={username}
//                   onChange={(e) => setUsername(e.target.value)}
//                   required
//                   style={{
//                     borderRadius: '25px',
//                     padding: '15px',
//                     fontSize: '1rem',
//                     marginBottom: '15px',
//                     border: '1px solid #ccc',
//                   }}
//                 />
//               </div>
//             </Form.Group>

//             <Form.Group controlId="formPassword">
//               <div className="input-group">
//                 <div className="input-group-prepend">
//                   <span
//                     className="input-group-text"
//                     style={{
//                       backgroundColor: '#007bff',
//                       borderRadius: '50%',
//                       color: 'white',
//                       padding: '10px',
//                       fontSize: '1.2rem',
//                     }}
//                   >
//                     <FaLock />
//                   </span>
//                 </div>
//                 <Form.Control
//                   type="password"
//                   placeholder="Password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   style={{
//                     borderRadius: '25px',
//                     padding: '15px',
//                     fontSize: '1rem',
//                     marginBottom: '15px',
//                     border: '1px solid #ccc',
//                   }}
//                 />
//               </div>
//             </Form.Group>

//             <Button
//               variant="primary"
//               type="submit"
//               block
//               disabled={loading}
//               style={{
//                 backgroundColor: '#007bff',
//                 border: 'none',
//                 borderRadius: '25px',
//                 padding: '15px',
//                 fontSize: '1.1rem',
//                 textTransform: 'uppercase',
//               }}
//             >
//               {loading ? 'Logging in...' : 'Log In'}
//             </Button>
//           </Form>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// };

// export default Login;






// import { useState, useEffect } from "react"
// import { Flame, Eye, EyeOff } from "lucide-react"

// export default function LoginPage({ onLogin }) {
//   const [email, setEmail] = useState("")
//   const [password, setPassword] = useState("")
//   const [showPw, setShowPw] = useState(false)
//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState("")
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth)

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth)
//     window.addEventListener("resize", handleResize)
//     return () => window.removeEventListener("resize", handleResize)
//   }, [])

//   const isMobile = windowWidth < 1024

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     if (!email || !password) {
//       setError("Please fill in all fields.")
//       return
//     }
//     setError("")
//     setLoading(true)
//     setTimeout(() => {
//       setLoading(false)
//       if (onLogin) onLogin()
//     }, 900)
//   }

//   return (
//     <div style={{ ...styles.container, flexDirection: isMobile ? "column" : "row" }}>
//       {/* Left panel (Stacks on top for mobile/tablets, side-by-side for desktops) */}
//       <div style={{ 
//         ...styles.leftPanel, 
//         display: "flex", 
//         width: isMobile ? "100%" : "50%",
//         padding: isMobile ? "32px 20px" : "64px" 
//       }}>
//         <div style={styles.leftPattern} />
//         <div style={styles.leftContent}>
//           <div style={styles.flameIconLarge}>
//             <Flame size={isMobile ? 36 : 44} />
//           </div>
//           <h1 style={{ ...styles.brandTitle, fontSize: isMobile ? "36px" : "48px" }}>
//             Pos.emedha.in
//           </h1>
//           <p style={{ ...styles.brandSubtitle, fontSize: isMobile ? "15px" : "18px", marginBottom: isMobile ? "24px" : "48px" }}>
//             Temple Management System
//           </p>
          
//           <div style={{
//             ...styles.statsGrid,
//             gridTemplateColumns: windowWidth < 480 ? "1fr" : "repeat(2, minmax(0, 1fr))"
//           }}>
//             {[
//               { label: "Active Poojas", value: "48" },
//               { label: "Today's Bookings", value: "214" },
//               { label: "Stock Items", value: "186" },
//               { label: "Revenue (₹)", value: "1.2L" },
//             ].map((s) => (
//               <div key={s.label} style={styles.statCard}>
//                 <p style={styles.statLabel}>{s.label}</p>
//                 <p style={styles.statValue}>{s.value}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Right panel (Form area) */}
//       <div style={{ 
//         ...styles.rightPanel, 
//         width: isMobile ? "100%" : "50%",
//         padding: isMobile ? "24px 16px" : "32px" 
//       }}>
//         <div style={styles.formWrapper}>
//           <div style={{ ...styles.loginCard, padding: isMobile ? "24px" : "32px" }}>
            
//             {/* Mobile Header (Shows inside card on small screens if desired, or you can keep it clean) */}
//             {isMobile && (
//               <div style={styles.mobileHeader}>
//                 <div style={styles.flameIconSmall}>
//                   <Flame size={20} />
//                 </div>
//                 <div>
//                   <h2 style={styles.mobileTitle}>Pooja Seva</h2>
//                   <p style={styles.mobileSubtitle}>Temple Management</p>
//                 </div>
//               </div>
//             )}

//             <h2 style={styles.welcomeTitle}>Welcome Back</h2>
//             <p style={styles.welcomeSubtitle}>Sign in to your admin account</p>

//             <form onSubmit={handleSubmit} style={styles.form}>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Email ID</label>
//                 <input
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="admin@temple.org"
//                   style={styles.input}
//                   onFocus={(e) => (e.target.style.borderColor = "#f97316")}
//                   onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
//                 />
//               </div>

//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Password</label>
//                 <div style={styles.passwordContainer}>
//                   <input
//                     type={showPw ? "text" : "password"}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     placeholder="••••••••"
//                     style={{ ...styles.input, paddingRight: "48px" }}
//                     onFocus={(e) => (e.target.style.borderColor = "#f97316")}
//                     onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPw(!showPw)}
//                     style={styles.eyeButton}
//                   >
//                     {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
//                   </button>
//                 </div>
//               </div>

//               {error && <p style={styles.errorText}>{error}</p>}

//               <button
//                 type="submit"
//                 disabled={loading}
//                 style={{
//                   ...styles.submitButton,
//                   background: loading ? "#fed7aa" : "linear-gradient(135deg, #f97316, #c2410c)",
//                   boxShadow: loading ? "none" : "0 4px 20px rgba(249,115,22,0.4)",
//                   cursor: loading ? "not-allowed" : "pointer"
//                 }}
//               >
//                 {loading ? "Signing in…" : "Sign In"}
//               </button>
//             </form>

//             <p style={styles.footerText}>Pooja Seva v2.4 · Temple Administration Portal</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     display: "flex",
//     background: "linear-gradient(135deg, #4a0e0e 0%, #7c2d12 40%, #c2410c 100%)",
//     fontFamily: "system-ui, -apple-system, sans-serif",
//     boxSizing: "border-box",
//   },
//   leftPanel: {
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     position: "relative",
//     overflow: "hidden",
//     boxSizing: "border-box",
//   },
//   leftPattern: {
//     position: "absolute",
//     inset: 0,
//     opacity: 0.1,
//     backgroundImage: "radial-gradient(circle at center, #fbbf24 1px, transparent 1px)",
//     backgroundSize: "28px 28px",
//   },
//   leftContent: {
//     position: "relative",
//     textAlign: "center",
//     width: "100%",
//     maxWidth: "440px",
//   },
//   flameIconLarge: {
//     width: "80px",
//     height: "80px",
//     margin: "0 auto 20px auto",
//     borderRadius: "50%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#ffffff",
//     background: "linear-gradient(135deg, #fbbf24, #f97316)",
//     boxShadow: "0 0 50px rgba(251,191,36,0.4)",
//   },
//   brandTitle: {
//     fontWeight: "bold",
//     color: "#ffffff",
//     marginBottom: "8px",
//     fontFamily: "'Cinzel', serif",
//     letterSpacing: "0.05em",
//   },
//   brandSubtitle: {
//     color: "#ffedd5",
//     fontFamily: "'Cinzel', serif",
//   },
//   statsGrid: {
//     display: "grid",
//     gap: "12px",
//     textAlign: "left",
//   },
//   statCard: {
//     borderRadius: "12px",
//     padding: "14px",
//     background: "rgba(255, 255, 255, 0.1)",
//     backdropFilter: "blur(8px)",
//   },
//   statLabel: {
//     color: "#ffedd5",
//     fontSize: "12px",
//     marginBottom: "4px",
//   },
//   statValue: {
//     color: "#ffffff",
//     fontSize: "20px",
//     fontWeight: "bold",
//   },
//   rightPanel: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxSizing: "border-box",
//   },
//   formWrapper: {
//     width: "100%",
//     maxWidth: "440px",
//   },
//   loginCard: {
//     borderRadius: "16px",
//     background: "rgba(255, 255, 255, 0.97)",
//     boxShadow: "0 32px 80px rgba(0, 0, 0, 0.3)",
//     boxSizing: "border-box",
//     width: "100%",
//   },
//   mobileHeader: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     marginBottom: "24px",
//   },
//   flameIconSmall: {
//     width: "40px",
//     height: "40px",
//     borderRadius: "50%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#ffffff",
//     background: "linear-gradient(135deg, #fbbf24, #f97316)",
//     flexShrink: 0,
//   },
//   mobileTitle: {
//     fontWeight: "bold",
//     color: "#111827",
//     fontFamily: "'Cinzel', serif",
//     margin: 0,
//     fontSize: "16px",
//   },
//   mobileSubtitle: {
//     fontSize: "12px",
//     color: "#6b7280",
//     margin: 0,
//   },
//   welcomeTitle: {
//     fontSize: "24px",
//     fontWeight: "bold",
//     color: "#111827",
//     marginBottom: "4px",
//     fontFamily: "'Cinzel', serif",
//   },
//   welcomeSubtitle: {
//     color: "#6b7280",
//     fontSize: "14px",
//     marginBottom: "24px",
//   },
//   form: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//   },
//   inputGroup: {
//     display: "flex",
//     flexDirection: "column",
//   },
//   label: {
//     display: "block",
//     fontSize: "14px",
//     fontWeight: "500",
//     color: "#374151",
//     marginBottom: "6px",
//   },
//   input: {
//     width: "100%",
//     padding: "12px 16px",
//     borderRadius: "12px",
//     border: "1px solid #e5e7eb",
//     fontSize: "14px",
//     outline: "none",
//     transition: "all 0.2s",
//     background: "#fdf8f3",
//     boxSizing: "border-box",
//   },
//   passwordContainer: {
//     position: "relative",
//     display: "flex",
//     alignItems: "center",
//   },
//   eyeButton: {
//     position: "absolute",
//     right: "12px",
//     background: "transparent",
//     border: "none",
//     cursor: "pointer",
//     color: "#9ca3af",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   errorText: {
//     color: "#ef4444",
//     fontSize: "14px",
//     margin: 0,
//   },
//   submitButton: {
//     width: "100%",
//     padding: "12px",
//     borderRadius: "12px",
//     fontWeight: "600",
//     color: "#ffffff",
//     fontSize: "14px",
//     border: "none",
//     transition: "all 0.2s",
//   },
//   footerText: {
//     textAlign: "center",
//     fontSize: "12px",
//     color: "#9ca3af",
//     marginTop: "20px",
//   },
// }


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { Flame, Eye, EyeOff } from 'lucide-react';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 1024;

  // Handle login form submission with your exact integration logic
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('https://posapi.emedha.in/api/login', { username, password });

      if (response.data && response.data.username) {
        sessionStorage.setItem('user_id', response.data.user_id);
        sessionStorage.setItem('username', response.data.username);
        sessionStorage.setItem('role', response.data.role);
        
        swal('Login Success', `Welcome ${response.data.role}`, 'success')
          .then(() => {
            if (response.data.role === "Admin") {
              navigate('/home');  // Redirect Admin to /home
            } else if (response.data.role === "Operator") {
              navigate('/operatorDashboard');  // Redirect Operator to /operatorDashboard
            }
          });
      } else {
        swal('Login Failed', 'Username or Password is Incorrect', 'error');
      }
    } catch (error) {
      swal('Login Failed', 'An error occurred during login', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ ...styles.container, flexDirection: isMobile ? 'column' : 'row' }}>
      {/* Left panel (Temple branding & stats - responsive layout) */}
      <div style={{ 
        ...styles.leftPanel, 
        width: isMobile ? '100%' : '50%',
        padding: isMobile ? '32px 20px' : '64px' 
      }}>
        <div style={styles.leftPattern} />
        <div style={styles.leftContent}>
          <div style={styles.flameIconLarge}>
            <Flame size={isMobile ? 36 : 44} />
          </div>
          <h1 style={{ ...styles.brandTitle, fontSize: isMobile ? '36px' : '48px' }}>
            Pos.emedha.in
          </h1>
          <p style={{ ...styles.brandSubtitle, fontSize: isMobile ? '15px' : '18px', marginBottom: isMobile ? '24px' : '48px' }}>
            Temple Management System
          </p>
          
          <div style={{
            ...styles.statsGrid,
            gridTemplateColumns: windowWidth < 480 ? '1fr' : 'repeat(2, minmax(0, 1fr))'
          }}>
            {[
              { label: 'Active Poojas', value: '48' },
              { label: "Today's Bookings", value: '214' },
              { label: 'Stock Items', value: '186' },
              { label: 'Revenue (₹)', value: '1.2L' },
            ].map((s) => (
              <div key={s.label} style={styles.statCard}>
                <p style={styles.statLabel}>{s.label}</p>
                <p style={styles.statValue}>{s.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right panel (Form card area) */}
      <div style={{ 
        ...styles.rightPanel, 
        width: isMobile ? '100%' : '50%',
        padding: isMobile ? '24px 16px' : '32px' 
      }}>
        <div style={styles.formWrapper}>
          <div style={{ ...styles.loginCard, padding: isMobile ? '24px' : '32px' }}>
            
            {/* Mobile Header Banner */}
            {isMobile && (
              <div style={styles.mobileHeader}>
                <div style={styles.flameIconSmall}>
                  <Flame size={20} />
                </div>
                <div>
                  <h2 style={styles.mobileTitle}>Pooja Seva</h2>
                  <p style={styles.mobileSubtitle}>Temple Management</p>
                </div>
              </div>
            )}

            <h2 style={styles.welcomeTitle}>Admin Sales Login</h2>
            <p style={styles.welcomeSubtitle}>Sign in to your admin account</p>

            <form onSubmit={handleLogin} style={styles.form}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                  required
                  style={styles.input}
                  onFocus={(e) => (e.target.style.borderColor = '#f97316')}
                  onBlur={(e) => (e.target.style.borderColor = '#e5e7eb')}
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Password</label>
                <div style={styles.passwordContainer}>
                  <input
                    type={showPw ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                    style={{ ...styles.input, paddingRight: '48px' }}
                    onFocus={(e) => (e.target.style.borderColor = '#f97316')}
                    onBlur={(e) => (e.target.style.borderColor = '#e5e7eb')}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPw(!showPw)}
                    style={styles.eyeButton}
                  >
                    {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  ...styles.submitButton,
                  background: loading ? '#fed7aa' : 'linear-gradient(135deg, #f97316, #c2410c)',
                  boxShadow: loading ? 'none' : '0 4px 20px rgba(249,115,22,0.4)',
                  cursor: loading ? 'not-allowed' : 'pointer',
                }}
              >
                {loading ? 'Logging in...' : 'Log In'}
              </button>
            </form>

            <p style={styles.footerText}>Pooja Seva v2.4 · Temple Administration Portal</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    background: 'linear-gradient(135deg, #4a0e0e 0%, #7c2d12 40%, #c2410c 100%)',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    boxSizing: 'border-box',
  },
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  leftPattern: {
    position: 'absolute',
    inset: 0,
    opacity: 0.1,
    backgroundImage: 'radial-gradient(circle at center, #fbbf24 1px, transparent 1px)',
    backgroundSize: '28px 28px',
  },
  leftContent: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    maxWidth: '440px',
  },
  flameIconLarge: {
    width: '80px',
    height: '80px',
    margin: '0 auto 20px auto',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    background: 'linear-gradient(135deg, #fbbf24, #f97316)',
    boxShadow: '0 0 50px rgba(251,191,36,0.4)',
  },
  brandTitle: {
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: '8px',
    fontFamily: "'Cinzel', serif",
    letterSpacing: '0.05em',
  },
  brandSubtitle: {
    color: '#ffedd5',
    fontFamily: "'Cinzel', serif",
  },
  statsGrid: {
    display: 'grid',
    gap: '12px',
    textAlign: 'left',
  },
  statCard: {
    borderRadius: '12px',
    padding: '14px',
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(8px)',
  },
  statLabel: {
    color: '#ffedd5',
    fontSize: '12px',
    marginBottom: '4px',
  },
  statValue: {
    color: '#ffffff',
    fontSize: '20px',
    fontWeight: 'bold',
  },
  rightPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },
  formWrapper: {
    width: '100%',
    maxWidth: '440px',
  },
  loginCard: {
    borderRadius: '16px',
    background: 'rgba(255, 255, 255, 0.97)',
    boxShadow: '0 32px 80px rgba(0, 0, 0, 0.3)',
    boxSizing: 'border-box',
    width: '100%',
  },
  mobileHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '24px',
  },
  flameIconSmall: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    background: 'linear-gradient(135deg, #fbbf24, #f97316)',
    flexShrink: 0,
  },
  mobileTitle: {
    fontWeight: 'bold',
    color: '#111827',
    fontFamily: "'Cinzel', serif",
    margin: 0,
    fontSize: '16px',
  },
  mobileSubtitle: {
    fontSize: '12px',
    color: '#6b7280',
    margin: 0,
  },
  welcomeTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: '4px',
    fontFamily: "'Cinzel', serif",
  },
  welcomeSubtitle: {
    color: '#6b7280',
    fontSize: '14px',
    marginBottom: '24px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s',
    background: '#fdf8f3',
    boxSizing: 'border-box',
  },
  passwordContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  eyeButton: {
    position: 'absolute',
    right: '12px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#9ca3af',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitButton: {
    width: '100%',
    padding: '12px',
    borderRadius: '12px',
    fontWeight: '600',
    color: '#ffffff',
    fontSize: '14px',
    border: 'none',
    transition: 'all 0.2s',
    textTransform: 'uppercase',
  },
  footerText: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#9ca3af',
    marginTop: '20px',
  },
};

export default Login;